import { Stack, TextField } from "@mui/material";
import React from "react";
import "./styles.scss";

export type Address = {
  address: string | null;
  apartment: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  country: string | null;
};

type AddressCompPropType = {
  address: Address;
  setAddress: Function;
  disabled?: boolean;
};

const AddressComp = (props: AddressCompPropType) => {
  const { address, setAddress, disabled } = props;

  const handleFieldChange = (
    fieldName: string,
    value: string | React.ChangeEvent<HTMLInputElement>
  ) => {
    if (typeof value === "string") {
      setAddress({
        ...address,
        [fieldName]: value,
      });
    } else {
      setAddress({
        ...address,
        [fieldName]: value.target.value,
      });
    }
  };

  return (
    <Stack spacing={3}>
      <TextField
        id="outlined-helperText"
        label="Address"
        size="small"
        fullWidth
        value={address?.address || ''}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          handleFieldChange("address", event);
        }}
        disabled={disabled}
      />
      <TextField
        id="outlined-helperText"
        label="Apartment / Unit #"
        size="small"
        className="textfield-width"
        value={address?.apartment || ''}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          handleFieldChange("apartment", event);
        }}
        disabled={disabled}
      />
      <Stack direction="row" spacing={2}>
        <TextField
          id="outlined-helperText"
          label="City"
          size="small"
          value={address?.city || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFieldChange("city", event);
          }}
          disabled={disabled}
        />
        <TextField
          id="outlined-helperText"
          label="State"
          size="small"
          value={address?.state || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFieldChange("state", event);
          }}
          disabled={disabled}
        />
        <TextField
          id="outlined-helperText"
          label="ZIP"
          size="small"
          value={address?.zip || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFieldChange("zip", event);
          }}
          disabled={disabled}
        />
      </Stack>
      <TextField
        id="outlined-helperText"
        label="Country"
        size="small"
        fullWidth
        value={address?.country ?? "USA"}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          handleFieldChange("country", event);
        }}
        disabled={disabled}
      />
    </Stack>
  );
};

export default AddressComp;
